import {
  ADD_RIDE_REQUEST,
  SET_RIDE_REQUESTS,
  UPDATE_RIDE_REQUEST,
} from "../actions/types";

const initialState = {
  requests: {},
};

const rideReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_RIDE_REQUESTS: {
      let rideRequestsObj = action.data.reduce((rides, ride) => {
        rides[ride.id + "r"] = ride;
        return rides;
      }, {});
      return {
        ...state,
        requests: rideRequestsObj,
      };
    }
    case ADD_RIDE_REQUEST: {
      return {
        ...state,
        requests: {
          [action.data.id + "r"]: action.data,
          ...state.requests,
        },
      };
    }
    case UPDATE_RIDE_REQUEST: {
      return {
        ...state,
        requests: {
          ...state.requests,
          [action.data.id + "r"]: {
            ...state.requests[action.data.id + "r"],
            ...action.data,
          },
        },
      };
    }
    default:
      return state;
  }
};

export default rideReducer;
